import { UserRoles } from '@omniafishing/core';
import React from 'react';
import { Link } from 'react-router-dom';
import { OmniaUrls } from '../../lib/urls';
import { isUserPublic } from '../../lib/user';

export const UserProfileLink = (props: {
  role: UserRoles;
  slug: string;
  className?: string;
  children: React.ReactNode;
  onClick?: () => void;
}) => {
  const { role, slug, children, className, onClick } = props;
  if (isUserPublic({ role })) {
    return (
      <Link to={OmniaUrls.ambassador(slug)} className={className} onClick={onClick}>
        {children}
      </Link>
    );
  }
  return (
    <span className={className} onClick={onClick}>
      {children}
    </span>
  );
};
